import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAreas = (citySlug?: string) => {
  return useQuery({
    queryKey: ['areas', citySlug],
    queryFn: async () => {
      let query = supabase
        .from('areas')
        .select(`
          id,
          name_en,
          name_ar,
          slug,
          description_en,
          description_ar,
          is_active,
          cities!inner (
            name_en,
            name_ar,
            slug
          )
        `)
        .eq('is_active', true);

      if (citySlug) {
        query = query.eq('cities.slug', citySlug);
      }

      const { data, error } = await query.order('name_en');
      
      if (error) throw error;
      return data;
    },
    enabled: true
  });
};

export const useAreaBySlug = (citySlug: string, areaSlug: string) => {
  return useQuery({
    queryKey: ['area', citySlug, areaSlug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('areas')
        .select(`
          id,
          name_en,
          name_ar,
          slug,
          description_en,
          description_ar,
          is_active,
          cities!inner (
            name_en,
            name_ar,
            slug
          )
        `)
        .eq('is_active', true)
        .eq('cities.slug', citySlug)
        .eq('slug', areaSlug)
        .single();
      
      if (error) throw error;
      return data;
    },
    enabled: !!citySlug && !!areaSlug
  });
}; 